<template>
      <div class="log-box sec">
        <form class="gen-form packages" v-on:submit.prevent="saveProfile">
          <h3>Tests taken</h3>
          <div v-for="test in tests" class="testtake">
            <div class="expires">
            <div class="name" v-if="test.video">{{ test.video.parent?test.video.parent.subtitle:test.video.subtitle }} {{ test.video.title }}</div>
              <div class="not-completed" v-if="!test.completed">
                <span>Not completed</span>
              </div>
              <div class="completed" v-else>
                <span>Completed</span>
                <em>correct {{ test.completed.result }} of {{ test.completed.answers.questions.questions.length }}</em>
              </div>
            </div>
            <a class="update" style="cursor: pointer" title="Allow again" v-on:click="allowAgain(test.id)">Allow again</a>
          </div>
          <div v-if="!tests.length">
            <div class="none">(no tests taken)</div>
          </div>
          <h3>Current subscriptions</h3>
          <div v-for="payment in item.activePayments" class="package">
            <div class="name">{{ payment.video?(videosById[payment.video]&&videosById[payment.video].password?"Test: ":"Video: ")+completeTitle(videosById[payment.video]):payment.videogroup && payment.videogroup.title }}</div>
            <div class="expires">Expires: <datepicker v-model="payment.endDate" /><!--{{ formatDate(payment.endDate, "MMM Do YYYY") }}--><a class="update" v-on:click="doUpdate(payment)">✓</a><a class="remove" v-on:click="doRemove(payment)">×</a></div>
          </div>
          <div v-if="!item.activePayments.length">
            <div class="none">(no active subscriptions)</div>
          </div>
          <h3>New subscription</h3>
          <div class="form-row">
            <label>Package subscription</label>
            <select v-model="newPackage">
              <option v-for="(option, optVal) in packageOpts" :value="optVal">{{ option }}</option>
            </select>
          </div>
          <div class="form-row">
            <div class="row-split">
            <label>Expiry date</label>
            <label class="checkbox"><input type="checkbox" v-model="newIndefinite" /><em></em> Indefinite</label>
            </div>
            <datepicker v-model="newExpires" v-if="!newIndefinite" />
          </div>
          <div class="form-row">
            <div class="row-split">
              <label>Start date</label>
              <label class="checkbox"><input type="checkbox" v-model="newNow" /><em></em> Now</label>
            </div>
            <datepicker v-model="newStart" v-if="!newNow" />
          </div>
          <div class="form-row row-buttons">
            <button class="lbtn" :disabled="!newPackage || (!newExpires && !newIndefinite)">Activate</button>
          </div>
          <div class="form-row row-buttons">
            <button class="lbtn" v-on:click.prevent="sendEmail">Send welcome email</button>
          </div>
          <h3>Past subscriptions</h3>
          <div v-for="payment in pastPayments" class="package">
            <div class="name">{{ payment.videogroup && payment.videogroup.title }}<br />{{ (payment.video && videosById[payment.video])?videosById[payment.video].title:"" }}</div>
            <div class="expires">Expires: <datepicker v-model="payment.endDate" /><a class="update" v-on:click="doUpdate(payment)">✓</a><a class="remove" v-on:click="doRemove(payment)">×</a><!--{{ formatDate(payment.endDate, "MMM Do YYYY") }}--></div>
          </div>
          <div v-if="!pastPayments.length">
            <div class="none">(no active subscriptions)</div>
          </div>
        </form>
       
      </div>
      
</template>
<script>
import api from './api';
import moment from 'moment';

export default {
  props: ["item"],
  data: ()=>({
    newPackage: null,
    newExpires: null,
    newIndefinite: false,
    newNow: true,
    newStart: null,
    newRangeEndDate: null,
    newRangeStartDate: null,
    packages: [],
    videosById: {},
    videos: [],
    tests: [],
  }),
  computed: {
    packageOpts() {
      var result={};
      for(var pkg of this.packages) {
        if (pkg.title) {
          result[pkg.id]=pkg.title;
        }
      }
      for(var vid of this.videos || []) {
        var typ="Video"
        if (vid.testqs && vid.testqs.independent.questions.length)
          typ="Test"
        var more=""
        if (vid.allVideos && vid.allVideos.length>1)
          more=" ("+vid.allVideos.length+" "+typ+"s)";
        if (typ=="Test" || vid.price1*1)
          result["-"+vid.id]=typ+": "+(vid.subtitle || "")+" "+vid.title+more;
      }
      return result;
    },
    pastPayments() {
      var now=moment().format("YYYY-MM-DD HH:mm:ss");
      return (this.item.allPayments || []).filter(a=>a.pastDueDate<now);
    },
  },
  methods: {
    completeTitle(video) {
      if (!video)
        return "";
      if (video.parent && video.parent.subtitle)
        return video.parent+" "+video.title;
      if (video.subtitle)
        return video.subtitle+" "+video.title;
      return video.title;
    },
    formatDate(date, format) {
      if (!date)
        return "";
      return moment(date).format(format);
    },
    async saveProfile() {
      var now=moment();
      if (this.newIndefinite)
        this.newExpires="2099-12-31";
      if (this.newNow)
        this.newStart=moment().format("YYYY-MM-DD");
      var expires=moment(this.newExpires);
      var diff=moment.duration(expires.diff(now));
      var days=Math.ceil(diff.as('days'));
      if (((this.newPackage || "")+"").indexOf("-")==-1) {
        var paymentId=(await api.create("Payment", {
          userid: this.item.id,
          status: "captured",
          sstatus: "cancelled",
          payment: {type: "admin", price: 0},
          videogroup: this.newPackage,
//           duration: days,      
          endDate: this.newExpires,
          pastDueDate: this.newExpires,
          startDate: this.newStart,
        })).id;
      } else {
        var paymentId=(await api.create("Payment", {
          userid: this.item.id,
          status: "captured",
          sstatus: "cancelled",
          payment: {type: "admin", price: 0},
          videogroup: null,
          video: this.newPackage.split("-")[1],
          endDate: this.newExpires,
          pastDueDate: this.newExpires,
          startDate: this.newStart,
        })).id;
      }
      this.$emit("update");
      this.newExpires=null;
      this.newIndefinite=false;
      appNotifications.show("New subscription created", "success");
    },
    async loadPackages() {
      this.packages=(await api.list("VideoGroup", {})).items || [];
    },
    async loadVideos() {
      var videos=(await api.list("Video", {parent: "null"}, ["title:ASC"])).items || [];
      this.videos=videos;
      for(var video of videos)
        this.$set(this.videosById, video.id, video);
    },
    async doUpdate(payment) {
      await api.update("Payment", payment.id, {
        endDate: payment.endDate,
        pastDueDate: payment.endDate,
      });
      appNotifications.show("Subscription updated", "success");
    },
    async doRemove(payment) {
      if (!confirm("Are you sure?"))
        return;
      await api.delete("Payment", payment.id);
      appNotifications.show("Subscription removed", "success");
      this.$emit("update");
    },
    async sendEmail() {
      if (!confirm("Are you sure?"))
        return;
      var password="PilatesAlliance";/*(await api.pin()).password;*/
      var u=(await api.update("User", this.item.id, {newPassword: password}, true)).item;
      if (u) {
        await api.action("User", u.id, "activationMail", {password: password});
      }
    },
    async loadTests() {
      var tests=(await api.list("TestUser", {userid: this.item.id})).items;
      var testsCompleted=(await api.list("TestTake", {userid: this.item.id}, ["id:DESC"])).items;
      for(var test of tests) {
        test.completed=testsCompleted.find((a)=>a.video && test.video && a.video.id==test.video.id) || null;
      }
      this.tests=tests;
    },
    async allowAgain(testuserid) {
      await api.delete("TestUser", testuserid);
      this.tests=this.tests.filter((a)=>a.id!=testuserid);
    },
    
  },
  created() {
    this.loadPackages();
    this.loadTests();
    this.loadVideos();
  },
}
</script>
